import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';

import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import HorizontalSelectRadioField from 'components/new_ui/Form/HorizontalSelectRadioField';

export default function Field({ item, active, afterClick }) {
  return (
    <div
      className={`scrollable-item pb-3 ${active ? '' : 'disabled'}`}
      data-block={item.attributes.block}
    >
      {item.attributes.answer_type === 'text' ? (
        <>
          <HorizontalTextField
            as="textarea"
            name={item.attributes.name}
            label={item.attributes.title}
            placeholder="Please add your comments here"
            rows={2}
          />

          <Button
            className="d-block mx-auto mb-4 disabled"
            onClick={(e) => {
              e.target.classList.add('disabled');
              e.target.parentElement.parentElement.classList.add('disabled');

              afterClick(e.target, e.target.parentElement.querySelector('textarea').value);
            }}
          >
            Next
          </Button>
        </>
      ) : (
        <HorizontalSelectRadioField
          name={item.attributes.name}
          label={item.attributes.title}
          containerClassName="select-counter-form"
          collection={item.attributes.answers.map((answer) => (
            { value: answer.weightage, label: answer.title }
          ))}
          onClick={(val, e) => {
            e.target.disabled = true;
            e.target.parentElement.classList.add('selected');

            /* eslint-disable no-restricted-syntax */
            for (const child of e.target.parentElement.parentElement.children) {
              child.classList.add('disabled');
            }
            /* eslint-enable no-restricted-syntax */

            afterClick(e.target, val);
          }}
        />
      )}
    </div>
  );
}

Field.propTypes = {
  item: PropTypes.object.isRequired,
  active: PropTypes.bool.isRequired,
  afterClick: PropTypes.func.isRequired,
};
